import React from 'react';
import {useSelector} from "react-redux";
import './DeleteModal.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const DeleteModal = props => {
    const { t } = useSelector(selector);
    const { closeMethod, deleteMethod, id, title, itemName } = props;

    const deleteItem = () => {
        deleteMethod(id);
        closeMethod();
    };

    return (
        <div className='modalBlur'>
            <div className='DeleteModal'>
                <div className='modalHeader'>
                    {t.gettext(title)}
                </div>
                <div className='modalForm'>
                    <div className='modalFormItem'>
                        {t.gettext('Do you really want to delete')} {itemName}?
                    </div>
                    <div className='modalFormButtons'>
                        <button className='modalFormButton modalFormButton--cancel' onClick={closeMethod}>
                            {t.gettext('CANCEL')}
                        </button>
                        <button className='modalFormButton modalFormButton--delete' onClick={deleteItem}>
                            {t.gettext('DELETE')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteModal;
